// generated by genversion
export var version = '4.3.5';
//# sourceMappingURL=version.js.map